var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videoID != null)?_c('div',{attrs:{"id":"banner"}},[_c('vimeo-player',{ref:"player",attrs:{"video-id":_vm.videoID,"options":_vm.options},on:{"ready":_vm.onReady}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }